module.exports = __webpack_public_path__ + "img/earth.8d09a94f.png";